import SecureLS from "secure-ls";

type JwtType = {
  refresh_token: string;
  access_token: string;
  access_expiry: string;
};

type StoreNameType =
  | "inawo"
  | "ref"
  | "userId"
  | "acc"
  | "pushSub"
  | "notifPrefs";

type StoreDataType = JwtType | string;

let ls =
  typeof window !== "undefined" &&
  new SecureLS({ encodingType: "aes", isCompression: true });

export const saveToStorage = (name: StoreNameType, key: StoreDataType) => {
  return typeof window !== "undefined" && !!ls && ls.set(name, key);
};

export const getFromStorage = (key: StoreNameType) => {
  return typeof window !== "undefined" && !!ls && ls.get(key);
};

export const removeFromStorage = (key: StoreNameType) => {
  return typeof window !== "undefined" && !!ls && ls.remove(key);
};

export const removeAllFromStorage = () => {
  return typeof window !== "undefined" && !!ls && ls.removeAll();
};
